<template>
  <div>
    <div v-if="$store.state.user">
      <div v-if="! externalClicked" class="card">
        <div class="card-header py-2">
          <button style="width: 100%" type="submit" class="btn btn-primary" @click="downloadExternalData">{{ $t('downloadExternalData') }}</button>
        </div>
      </div>
      <div :style="{display: externalClicked ? 'block' : 'none'}">
        <button :disabled="cacheThumbsInProgress" style="width: 100%" type="submit" class="btn btn-primary" @click="cacheThumbs"><Spinner v-if="cacheThumbsInProgress" margin_right="10px" height="20px" />{{ $t('cacheThumbs') }}</button>
        <br>
        <br>
        <div style="width: 100%; margin-bottom: 8px;">
          <VueSelect style="width: 100%" v-model="selectedAreaLocal" :options="areaOptions" :clearable="true" :searchable="false" placeholder="" />
        </div>
        <template v-if="cacheThumbsInProgress || cacheThumbsDone">
          <BProgress :max="cacheTotalFiles" height="30px">
            <BProgressBar :value="cacheProcessed">
              <span><strong>{{ cacheProcessed }} / {{ cacheTotalFiles }}</strong></span>
            </BProgressBar>
          </BProgress>
          <br>
        </template>
        <CzasWLasCard></CzasWLasCard>
        <br>
        <OpenStreetMapPointsCard></OpenStreetMapPointsCard>
        <br>
        <KomootTrailViewCard></KomootTrailViewCard>
        <br>
        <KomootHighlightPoiCard></KomootHighlightPoiCard>
        <br>
        <KomootToursCard></KomootToursCard>
        <br>
        <StravaSegmentsCard></StravaSegmentsCard>
        <br>
        <DPozCard></DPozCard>
        <br>
        <BDLCard></BDLCard>
        <br>
        <GSMCard></GSMCard>
      </div>
      <br>  
    </div>
    <PlaceTypeGroupCard v-for="placeTypeGroup in placeTypeGroups" :placeTypeGroup="placeTypeGroup" :key="placeTypeGroup.id" :refresh="refresh"></PlaceTypeGroupCard>
    <MapPlace v-for="place of $store.state.maplasPlaces[$DataOrigin.maplas]" :key="place.id" :place="place"></MapPlace>
    <AppTrackGroup :searchText="''" :trackGroup="plannedTrackGroup" :showDetails="false"></AppTrackGroup>
    <br>
    <PlannedTracks></PlannedTracks>
    <AppTrackGroup :searchText="''" :trackGroup="otherPeopleTrackGroup" :showDetails="true"></AppTrackGroup>
    <br>
    <AppTrackGroup :searchText="''" :trackGroup="eventTrackGroup" :showDetails="true"></AppTrackGroup>
    <br>
    <AppTrackGroup :searchText="''" :trackGroup="trailTrackGroup" :showDetails="true"></AppTrackGroup>
    <br>
    <AppTrackGroup :searchText="''" :trackGroup="borderTrackGroup" :showDetails="false"></AppTrackGroup>
    <br>
    <div class="card">
      <div class="card-header py-2">
        {{ $t('tmpPoints') }}
      </div>
      <div class="card-body">
        <form @submit.prevent="addPoint">
          <div style="width: 100%" class="form-group">
            {{ $t('name') }}:
            <input style="width: 100%" type="text" v-model="name" class="form-control mr-2">
            {{  $t('coordinates') }}:
          </div>
          <div style="width: 100%" class="form-group flex-form-group">
            <input style="width: 75%; margin-right: 5px" type="text" v-model="newPoint" class="form-control">
            <button :disabled="! (isPointOK(newPoint)[0])" style="width: 25%" type="submit" class="btn btn-primary">{{ $t('add') }}</button>
          </div>
        </form>  
      </div>
    </div>
    <br>
    <div class="card">
      <div class="card-header py-2">
        {{ $t('centerMap') }}
      </div>
      <div class="card-body">
        <form @submit.prevent="centerMap">
          <div style="width: 100%" class="form-group">
            {{  $t('coordinates') }}:
          </div>
          <div style="width: 100%" class="form-group flex-form-group">
            <input style="width: 75%; margin-right: 5px" type="text" v-model="centerPoint" class="form-control">
            <button :disabled="! (isPointOK(centerPoint)[0])" style="width: 25%" type="submit" class="btn btn-primary">{{ $t('center') }}</button>
          </div>
        </form>  
      </div>
    </div> 
  </div>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import { EventBus } from '@/ts/EventBus';
import TrackGroup from '@/ts/TrackGroup';
import Track from '@/ts/Track';
import * as opfs_utils from '@/ts/utils/opfs';
import { defineComponent } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        const placeTypeGroups: any = null;

        return {
            plannedTrackGroup: new TrackGroup(),
            eventTrackGroup: new TrackGroup(),
            otherPeopleTrackGroup: new TrackGroup(),
            borderTrackGroup: new TrackGroup(),
            trailTrackGroup: new TrackGroup(),
            placeTypeGroups,
            refresh: 1,
            newPoint: '',
            centerPoint: '',
            name: '',
            externalClicked: false,
            cacheThumbsInProgress: false,
            cacheThumbsDone: false,
            cacheTotalFiles: 0,
            cacheProcessed: 0,
            areaOptions: [] as any[],
            selectedAreaLocal: null as any
        };
    },
    mounted() {
        this.plannedTrackGroup.label = 'plannedTracks';
        this.plannedTrackGroup.translate = 'plannedTracks';
        this.eventTrackGroup.label = 'eventTracks';
        this.eventTrackGroup.translate = 'eventTracks';
        this.otherPeopleTrackGroup.label = 'otherPeopleTracks';
        this.otherPeopleTrackGroup.translate = 'otherPeopleTracks';
        this.borderTrackGroup.label = 'borderTracks';
        this.borderTrackGroup.translate = 'borderTracks';
        this.trailTrackGroup.label = 'trailTracks';
        this.trailTrackGroup.translate = 'trailTracks';
        //@ts-ignore
        this.createTrackGroupFromTracks(this.plannedTrackGroup, this.$store.state.plannedTracks);
        //@ts-ignore
        this.createTrackGroupFromTracks(this.eventTrackGroup, this.$store.state.eventTracks);
        //@ts-ignore
        this.createTrackGroupFromTracks(this.otherPeopleTrackGroup, this.$store.state.otherPeopleTracks);
        //@ts-ignore
        this.createTrackGroupFromTracks(this.borderTrackGroup, this.$store.state.borderTracks);
        //@ts-ignore
        this.createTrackGroupFromTracks(this.trailTrackGroup, this.$store.state.trailTracks);
        EventBus.$on('RefreshPlacesGroups', this.onStorePlacesChanged);
        // build area options for select (empty option first)
        try {
          const opts: any[] = [{label: '', value: ''}];
          // @ts-ignore
          for (const k of Object.keys(window.areas)) {
            opts.push({label: k.replace(/_/g, ' '), value: k});
          }
          this.areaOptions = opts;
          // @ts-ignore
          const sel = (window.selectedArea) ? this.areaOptions.find((o: any) => o.value === window.selectedArea) : this.areaOptions[0];
          this.selectedAreaLocal = sel || this.areaOptions[0];
        } catch (e) {
          this.areaOptions = [{label: '', value: ''}];
          this.selectedAreaLocal = this.areaOptions[0];
        }
    },
    
    methods: {
        downloadExternalData() {
            this.externalClicked = true;
            EventBus.$emit("downloadExternalData");
        },
            onSelectedAreaLocalChanged(newVal: any, oldVal: any) {
              // @ts-ignore
              window.selectedArea = newVal && newVal.value ? newVal.value : '';
              EventBus.$emit('selectedAreaChanged', window.selectedArea, oldVal ? oldVal.value : '');
            },
        async cacheThumbs() {
            this.cacheThumbsInProgress = true;
            this.cacheTotalFiles = 0;
            this.cacheProcessed = 0;
            const keys = ["czaswlas", "komoothighlight", "komootother", "komoottrailview", "komoottour"];
            for (const key of keys) {
              //@ts-ignore
              for (const place of window.externalPlaces[key]) {
                this.cacheTotalFiles += place.photos.length
              }
            }
            for (const key of keys) {   
              //@ts-ignore
              for (const place of window.externalPlaces[key]) {
                for (const photo of place.photos) {
                  await opfs_utils.checkOrCachePhoto(photo.image_thumb);
                  this.cacheProcessed += 1;
                }
              }
            }
            this.cacheThumbsInProgress = false;
            this.cacheThumbsDone = true;
        },
        createTrackGroupFromTracks(trackGroup: TrackGroup, tracks: Array<Track>) {
            trackGroup.tracks = [];
            for(const track of tracks) {
              trackGroup.tracks.push(track);
            }
        },
        isNumber(value: string) {
            if (!Number.isNaN(value)) {
              return true;
            } else {
              return false;
            }
        },
        isPointOK(point: string) {
            const splitsComa = point.trim().split(',')
            if (splitsComa.length == 2) {
              const lat = splitsComa[0].trim();
              const lon = splitsComa[1].trim();
              if ((lat) && (lon) && (this.isNumber(lat)) && (this.isNumber(lon))) {
                return [true, lat, lon];
              }
            }
            const splitsSpace = point.trim().split(' ')
            if (splitsSpace.length == 2) {
              const lat = splitsSpace[0].trim();
              const lon = splitsSpace[1].trim();
              if ((lat) && (lon) && (this.isNumber(lat)) && (this.isNumber(lon))) {
                return [true, lat, lon];
              }
            }
            return [false, null, null];
        },
        tmpMarkerClick(event: L.LeafletMouseEvent, marker: L.CircleMarker) {
            if (event.originalEvent.ctrlKey || event.originalEvent.metaKey || event.originalEvent.shiftKey) {
              marker.removeFrom(window.mainmap);
            }
        },
        addPoint() {
            const result: any = this.isPointOK(this.newPoint);
            const isok = result[0];
            const lat = result[1];
            const lon = result[2];
            if (isok) {
              const marker = new L.CircleMarker([lat, lon], {'radius': 6, color: 'black'});
              if (this.name) {
                marker.bindPopup('<b>' + this.name + '</b><br>' + String(lat) + ', ' + String(lon));
              } else {
                marker.bindPopup(String(lat) + ', ' + String(lon));
              }
              marker.addTo(window.mainmap);
              marker.on('click', (e: L.LeafletMouseEvent) => {this.tmpMarkerClick(e, marker)});
              window.mainmap.setView([lat, lon]);
              this.newPoint = '';
              this.name = '';
            }
        },
        centerMap() {
            const result: any = this.isPointOK(this.centerPoint);
            const isok = result[0];
            const lat = result[1];
            const lon = result[2];
            if (isok) {
              window.mainmap.setView([lat, lon]);
              this.centerPoint = '';
              const marker = new L.CircleMarker([lat, lon], {'radius': 11, color: 'black'});
              marker.addTo(window.mainmap);
              setTimeout(() => {
                marker.removeFrom(window.mainmap);
              }, 2000);
            }
        },
        onStorePlacesChanged(value: string, oldValue: string) {
            if ((this.$store.state.places) && (this.$store.state.placeTypes)) {
              const placeTypeGroups: any = {};
              for (const placeType of this.$store.state.placeTypes) {
                // @ts-ignore
                if (! (placeType.group.id in placeTypeGroups)) {
                  // @ts-ignore
                  placeTypeGroups[placeType.group.id] = {'id': placeType.group.id, 'name': placeType.group.name, 'placeGroups': {}};
                }
              }
              for (const placeType of this.$store.state.placeTypes) {
                // @ts-ignore
                placeTypeGroups[placeType.group.id]['placeGroups'][placeType.id] = {'id': placeType.id, 'name': placeType.name, 'icon': placeType.icon, places: [], 'checked': false};
              }
              for (const place of this.$store.state.places) {
                // @ts-ignore
                placeTypeGroups[place.type.group.id]['placeGroups'][place.type.id].places.push(place);
              }
              if (this.placeTypeGroups) {
                for (const placeType of this.$store.state.placeTypes) {
                  // @ts-ignore
                  placeTypeGroups[placeType.group.id]['placeGroups'][placeType.id]['checked'] = this.placeTypeGroups[placeType.group.id]['placeGroups'][placeType.id]['checked'];
                }
              }
              this.placeTypeGroups = placeTypeGroups;
              this.refresh = this.refresh + 1;
            }
        },
        onStoreZoomChanged(value: boolean, oldValue: boolean) {
            for (const place of this.$store.state.places) {
              place.changeMarkerSize(this.$store.state.zoomLevel);
            }
        },
        onPlannedTracksChange() {
            //@ts-ignore
            this.createTrackGroupFromTracks(this.plannedTrackGroup, this.$store.state.plannedTracks);
        },
        onEventTracksChange() {
            //@ts-ignore
            this.createTrackGroupFromTracks(this.eventTrackGroup, this.$store.state.eventTracks);
        },
        onOtherPeopleTracksChange() {
            //@ts-ignore
            this.createTrackGroupFromTracks(this.otherPeopleTrackGroup, this.$store.state.otherPeopleTracks);
        },
        onBorderTracksChange() {
            //@ts-ignore
            this.createTrackGroupFromTracks(this.borderTrackGroup, this.$store.state.borderTracks);
        },
        onTrailTracksChange() {
            //@ts-ignore
            this.createTrackGroupFromTracks(this.trailTrackGroup, this.$store.state.trailTracks);
        }
    },
    watch: {
        "$store.state.places": [{
            handler: "onStorePlacesChanged"
        }],
        "selectedAreaLocal": [{
          handler: "onSelectedAreaLocalChanged"
        }],
        "$store.state.placeTypes": [{
            handler: "onStorePlacesChanged"
        }],
        "$store.state.zoomLevel": [{
            handler: "onStoreZoomChanged"
        }],
        "$store.state.plannedTracks": [{
            handler: "onPlannedTracksChange"
        }],
        "$store.state.eventTracks": [{
            handler: "onEventTracksChange"
        }],
        "$store.state.otherPeopleTracks": [{
            handler: "onOtherPeopleTracksChange"
        }],
        "$store.state.borderTracks": [{
            handler: "onBorderTracksChange"
        }],
        "$store.state.trailTracks": [{
            handler: "onTrailTracksChange"
        }]
    }
})


</script>